import React from 'react';
import PropTypes from 'prop-types';

import { getClass } from '../../../utils/component-helpers';
import Icon from '../icon/icon';

import './button.scss';

const Button = props => {
  const {
    onClick,
    kind,
    color,
    size,
    disabled,
    iconStart,
    iconEnd,
    iconOnly,
    iconSize,
    label,
    submit,
  } = props;
  const buttonClasses = getClass('base-btn', kind, color, size, {
    'icon-only': iconOnly,
  });

  if (iconOnly) {
    return (
      <button
        type={submit ? 'submit' : 'button'}
        onClick={onClick}
        className={buttonClasses}
        disabled={disabled}
      >
        <div className="button-icon-container">
          <Icon size={iconSize} iconName={iconOnly} />
        </div>
      </button>
    );
  }

  return (
    <button
      type={submit && 'submit'}
      onClick={e => {
        e.stopPropagation();
        onClick(e);
      }}
      className={buttonClasses}
      disabled={disabled}
    >
      {iconStart && (
        <div className="button-icon-container start">
          <Icon size={iconSize} iconName={iconStart} color="inherit" />
        </div>
      )}
      {label}
      {iconEnd && (
        <div className="icon-container end">
          <Icon size={iconSize} iconName={iconEnd} />
        </div>
      )}
    </button>
  );
};

Button.propTypes = {
  kind: PropTypes.oneOf(['primary', 'secondary', 'text']),
  color: PropTypes.oneOf(['default', 'destructive']),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'large']),
  disabled: PropTypes.bool,
  iconStart: PropTypes.string,
  iconEnd: PropTypes.string,
  iconOnly: PropTypes.string,
  iconSize: PropTypes.number,
  label: PropTypes.string,
};

Button.defaultProps = {
  kind: 'primary',
  color: 'default',
  onClick: () => {},
  size: 'small',
  disabled: false,
  iconStart: '',
  iconEnd: '',
  iconOnly: '',
  iconSize: 16,
  label: 'Click Here',
};

export default Button;
